import IconButton from '@material-ui/core/Button';
import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import useTableButtonStyle from './TableButtonStyle';

const ParentDirectoryButton = (props) => {
    const { path, setSelectedFileSystemNodePath } = props;
    const classes = useTableButtonStyle();
    const handleClick = () => {
        setSelectedFileSystemNodePath(path, 'directory');
    }
    return (<>
        <IconButton size="small" className={classes.root}  onClick={handleClick}>
            <ArrowUpwardIcon size="small"/>
        </IconButton>
    </>);
}
export default ParentDirectoryButton;